/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import Page from '../../../../Page';
import { LoadingButton } from '@material-ui/lab';
import {
    Card,
    CardMedia,
    Grid,
    TextField,
    Container,
    Tooltip,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Stack,
    Button,
    ButtonGroup,
    FormControl,
    InputLabel,
    FormHelperText,
    Checkbox,
    Chip
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import services from '../../Service';
import { ToastContainer, toast } from 'react-toastify';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { AlertDialog } from '../../../Common/AlertDialog';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import ImageUploader from 'react-images-upload';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';

var screenCode = "FARMER"

export function Certification({ handleNext, handleBack, farmerId, handleFinish }) {
    const [message, setMessage] = useState("Delete Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [farmerCertificationID, setFarmerCertificationID] = useState();
    const [farmerCertificationArray, setFarmerCertificationArray] = useState([]);
    const [groupFactory, setGroupFactory] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [factoryType, setFactoryType] = useState(0);
    const [product, setProduct] = useState([]);
    const [farmerCertificationType, setFarmerCertificationType] = useState([]);
    const [ImageObject, setImageObject] = useState(null);
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);
    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [openA, setOpenA] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        Edit: false,
        submitButtonName: "Add",
        pageheadername: "Add Certification details"
    });

    const [formData, setFormData] = useState({
        certificationTypeID: 0,
        certificationNumber: '',
        operationEntityID: 0,
        operationEntityName: '',
        productCategoryID: '',
        productID: '',
        image: '',
        expireDate: ''
    });

    const CertificationSaveSchema = Yup.object().shape({
        certificationTypeID: Yup.number().min(1, 'Certification Type required').required('Certification Type required'),
        certificationNumber: Yup.string().min(1, 'Certification Number is Required').required('Certification Number is Required'),
        productCategoryID: Yup.array().min(1, 'Product Category is Required').required('Product Category Required'),
        productID: Yup.array().min(1, 'Product is Required').required('Product is Required'),
        expireDate: Yup.string().required('Expire Date is Required')
    });

    const formik = useFormik({
        initialValues: {
            certificationTypeID: formData.certificationTypeID,
            certificationNumber: formData.certificationNumber,
            operationEntityID: formData.operationEntityID,
            operationEntityName: formData.operationEntityName,
            productCategoryID: selectedCategoryOptions,
            productID: selectedProductOptions,
            image: formData.image,
            expireDate: formData.expireDate,
        },
        validationSchema: CertificationSaveSchema,
        onSubmit: (values) => {
            if (values.image !== '') {
                addGrid(values);
            } else {
                toast.error("Please Add a Certification Image");
            }
        },
        enableReinitialize: true
    });
    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        handleFinish();
    }, []);

    useEffect(() => {
        getPermissions();
        trackPromise(GetFarmerCertificationByFarmerID());
        trackPromise(GetProductCategoties());

    }, []);

    useEffect(() => {
        (GetCollectionCenterByFarmerID());
    }, [farmerId]);

    useEffect(() => {
        trackPromise(GetAllFarmerCertificationType())
    }, [farmerId]);

    useEffect(() => {
        if (selectedCategoryOptions.length > 0) {
            trackPromise(GetProductDetails())
        }
    }, [selectedCategoryOptions])

    useEffect(() => {
        setValues({
            ...values,
            productID: selectedProductOptions,
            productCategoryID: selectedCategoryOptions,
            expireDate: ''
        })
    }, [selectedProductOptions, selectedCategoryOptions]);

    useEffect(() => {
        setValues({
            ...values,
            expireDate: ''
        })
        setSelectedProductOptions([]);
    }, [selectedCategoryOptions]);

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setImageObject(null);
        setValues({
            ...values,
            image: ""
        });
        setOpen(false);
    }

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFARMER');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });
        setGroupFactory({
            ...groupFactory,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        setFactoryType(parseInt(TokenDecoder.getFactoryTypeFromToken()))

    }

    async function GetAllFarmerCertificationType() {
        const res = await services.GetAllFarmerCertificationType()
        setFarmerCertificationType(res)
    }

    async function GetProductCategoties() {
        var res = await services.GetProductCategoties()
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productCategoryName, value: res[i].productCategoryID })
            }
            setProductcatogery(newOptionArray);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductsByFactoryIDProductcatogeryID(formik.values.operationEntityID, selectedCategoryOptions.map(x => x).join(","))
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productName, value: res[i].productID })
            }
            setProduct(newOptionArray);
        }
    }

    async function GetCollectionCenterByFarmerID() {
        var res = await services.GetCollectionCenterByFarmerID(farmerId);
        if (res != null) {
            setOperationEntityList(res);
            res.forEach(x => {
                if (x.farmerID === farmerId) {
                    setValues({
                        ...values,
                        operationEntityID: x.collectionCenterID,
                        operationEntityName: x.factoryName
                    })
                }
            });
        }
    }

    function onDrop(picture, imageUrl) {
        if (imageUrl.length == 0) {
            toast.error("Image not supported");
            return;
        }
        else {
            var convertedString = imageUrl[0];
            var fields = convertedString.split(",");
            var fields2 = fields[0].split(";");
            var fields3 = fields2[1].split("=");
            var fields4 = fields3[1].split(".");

            setImageObject(fields[1]);
            setValues({
                ...values,
                image: fields[1]
            });
        }
    }

    async function addGrid(values) {
        if (pageProps.Edit != true) {
            let farmerCertification = {
                farmerCertificationID: parseInt(0),
                farmerID: parseInt(farmerId),
                createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                certificationTypeID: parseInt(values.certificationTypeID),
                certificationNumber: values.certificationNumber,
                operationEntityID: parseInt(values.operationEntityID),
                image: values.image,
                expireDate: values.expireDate,
                productCategoryID: selectedCategoryOptions,
                productID: selectedProductOptions
            };

            const farmerCertifications = [farmerCertification];
            const res = await services.SaveFarmerCertificationDetail(farmerCertifications);
            if (res.statusCode == 'Success') {
                toast.success("Farmer Certification Details Saved Succesfully");
                setImageObject(null);
                trackPromise(GetFarmerCertificationByFarmerID(farmerId));
                clearAll();
            } else {
                toast.error("Certification Number Already Exists.");
                clearAll();
            }
        }
    }

    async function GetFarmerCertificationByFarmerID() {
        var res = await services.GetFarmerCertificationByFarmerID(farmerId);
        if (res.statusCode === "Success") {
            const groupedData = res.data.reduce((acc, curr) => {
                const { farmerCertificationID, certificationNumber, farmerID, expireDate, farmerCertificationTypeName, image, imageLink, imageURL, productCategoryName, productName } = curr;
                if (!acc[certificationNumber]) {
                    acc[certificationNumber] = {
                        farmerCertificationIDs: [farmerCertificationID],
                        certificationNumber,
                        farmerID,
                        expireDate,
                        farmerCertificationTypeName,
                        image,
                        imageLink,
                        imageURL,
                        productCategoryNames: [productCategoryName],
                        productNames: [productName]
                    };
                } else {
                    acc[certificationNumber].farmerCertificationIDs.push(farmerCertificationID);
                    if (!acc[certificationNumber].productCategoryNames.includes(productCategoryName)) {
                        acc[certificationNumber].productCategoryNames.push(productCategoryName);
                    }
                    acc[certificationNumber].productNames.push(productName);
                }
                return acc;
            }, {});

            const groupedArray = Object.values(groupedData);
            groupedArray.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
            setFarmerCertificationArray(groupedArray);
        }
    }


    async function DeleteItem(index) {
        const certificationIDs = farmerCertificationArray[index].farmerCertificationIDs;
        if (certificationIDs !== undefined && certificationIDs.length > 0) {
            let successCount = 0;
            for (const certificationID of certificationIDs) {
                const res = await services.DeleteFarmerCertificationDetail(certificationID);
                if (res.data === 1) {
                    successCount++;
                } else {
                    toast.error('Error occurred in Deleting Farmer Certification Detail');
                }
            }
            if (successCount === certificationIDs.length) {
                setFarmerCertificationArray(prevState => prevState.filter((_, i) => i !== index));
                toast.success('Farmer Certification Details Deleted Successfully');
            } else {
                toast.error('Farmer Certification Details could not be deleted');
            }
        }
    }

    async function clearAll() {
        setValues({
            ...values,
            certificationTypeID: 0,
            expireDate: '',
            productCategoryID: 0,
            productID: 0,
            certificationNumber: '',
            image: ''
        })
        setImageObject(null);
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    }

    async function removeImage() {
        setOpen(true);
    }

    function settingPicture(data, type) {
        if (data != null || data != undefined) {
            var fulldata =
                type === 'png'
                    ? `data:image/png;base64,${data}`
                    : `data:image/jpg;base64,${data}`;
            return (
                <img
                    src={fulldata}
                    width="60"
                    height="60"
                    onClick={() => handleImageClick(fulldata)}
                    style={{ cursor: 'pointer' }}
                />
            );
        } else {
            return (
                <ImageSearchIcon
                    style={{
                        color: 'blue',
                        marginBottom: '-1rem',
                        marginTop: '0rem',
                        cursor: 'pointer'
                    }}
                    size="small"
                    onClick={() => handleImageClick('defaultImageURL')}
                />
            );
        }
    }

    function confirmData(y) {
        if (y) {
            DeleteItem(farmerCertificationID);
        }
    }

    const handleSelectProductChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedProductOptions(selectedProductOptions.length === product.length ? [] : product.map((option) => option.value));
        } else {
            setSelectedProductOptions(value);
        }
    };

    const handleClearProductSelection = () => {
        setSelectedProductOptions([]);
    };

    const handleSelectCategoryChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedCategoryOptions(selectedCategoryOptions.length === productcatogery.length ? [] : productcatogery.map((option) => option.value));
        } else {
            setSelectedCategoryOptions(value);
        }
    };

    const handleClearCategorySelection = () => {
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleCloseA = () => {
        setOpenA(false);
    };

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(<MenuItem key={x.farmerCertificationType} value={x.farmerCertificationTypeID}>{x.farmerCertificationTypeName}</MenuItem>)
            });
        }
        return items
    }

    const handleImageClick = (image) => {
        setSelectedImage(image);
        setOpenA(true);
    };

    function handleConfirm(data) {
        setFarmerCertificationID(data);
        setEnableConfirmMessage(true);
    }

    const renderCategorySelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = productcatogery.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderProductSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = product.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Certification Details  |  FAPS">
                <Container>
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate onSubmit={handleSubmit}
                        >
                            <Card style={{ justifycontent: 'center' }} >
                                <Stack spacing={2} margin={3}>
                                    <Typography variant="h6">{(factoryType == 1 || factoryType == 3) ? "View Certification Details" : "Certification Details"}
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <ButtonGroup disableElevation variant="outlined" color="primary">
                                                <Tooltip title="Cargills Connect">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={handleBack}
                                                    >
                                                        <ArrowBackIosOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </ButtonGroup>
                                        </Stack>
                                    </Typography>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Stack width={350}>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Certification Type *"
                                                name="certificationTypeID"
                                                value={formik.values.certificationTypeID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('certificationTypeID')}
                                                error={Boolean(touched.certificationTypeID && errors.certificationTypeID)}
                                                helperText={touched.certificationTypeID && errors.certificationTypeID}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            >
                                                <MenuItem key={0} value={0} > Select Certification Type</MenuItem>
                                                {generateDropDownMenu(farmerCertificationType)}
                                            </TextField>
                                        </Stack>
                                        <Stack width={350}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Certification Number *"
                                                value={formik.values.certificationNumber}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('certificationNumber')}
                                                error={Boolean(touched.certificationNumber && errors.certificationNumber)}
                                                helperText={touched.certificationNumber && errors.certificationNumber}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            />
                                        </Stack>
                                        <Stack width={350}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Land *"
                                                value={formik.values.operationEntityName}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('operationEntityName')}
                                                error={Boolean(touched.operationEntityName && errors.operationEntityName)}
                                                helperText={touched.operationEntityName && errors.operationEntityName}
                                                InputLabelProps={{ shrink: true }}
                                                disabled={factoryType == 1 || factoryType == 3}
                                                InputProps={{
                                                    readOnly: true
                                                }}
                                            />
                                        </Stack>
                                    </Stack>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Stack width={350}>
                                            <FormControl fullWidth error={Boolean(touched.productCategoryID && errors.productCategoryID)}>
                                                <InputLabel id="multi-select-label">Product Category * </InputLabel>
                                                <Select
                                                    className="custom-select"
                                                    labelId="multi-select-label"
                                                    id="multi-select"
                                                    multiple
                                                    size="small"
                                                    value={selectedCategoryOptions}
                                                    onChange={handleSelectCategoryChange}
                                                    label="Product Category "
                                                    disabled={factoryType == 1 || factoryType == 3}
                                                    renderValue={(selected) => renderCategorySelectedValue(selected)}
                                                >
                                                    <MenuItem key={0} value={''}>
                                                        <Checkbox checked={selectedCategoryOptions.length === productcatogery.length} color="primary" />
                                                        All Product Category
                                                    </MenuItem>
                                                    {productcatogery.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            <Checkbox checked={selectedCategoryOptions.indexOf(option.value) > -1} color="primary" />
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                {touched.productCategoryID && errors.productCategoryID && (
                                                    <FormHelperText>{errors.productCategoryID}</FormHelperText>
                                                )}
                                                {selectedCategoryOptions.length > 0 && (
                                                    <IconButton onClick={handleClearCategorySelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                        <ClearIcon />
                                                    </IconButton>
                                                )}
                                            </FormControl>
                                        </Stack>
                                        <Stack width={350}>
                                            <FormControl fullWidth error={Boolean(touched.productID && errors.productID)}>
                                                <InputLabel id="multi-select-label">Product * </InputLabel>
                                                <Select
                                                    className="custom-select"
                                                    labelId="multi-select-label"
                                                    id="multi-select"
                                                    multiple
                                                    size="small"
                                                    value={selectedProductOptions}
                                                    onChange={handleSelectProductChange}
                                                    label="Product"
                                                    disabled={selectedCategoryOptions.length == 0 || factoryType == 1 || factoryType == 3}
                                                    renderValue={(selected) => renderProductSelectedValue(selected)}
                                                >
                                                    <MenuItem key={0} value={''}>
                                                        <Checkbox checked={selectedProductOptions.length === product.length} color="primary" />
                                                        All Products
                                                    </MenuItem>
                                                    {product.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            <Checkbox checked={selectedProductOptions.indexOf(option.value) > -1} color="primary" />
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                {touched.productID && errors.productID && (
                                                    <FormHelperText>{errors.productID}</FormHelperText>
                                                )}
                                                {selectedProductOptions.length > 0 && (
                                                    <IconButton onClick={handleClearProductSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                        <ClearIcon />
                                                    </IconButton>
                                                )}
                                            </FormControl>
                                        </Stack>
                                        <Stack width={350}>
                                            <TextField
                                                fullWidth
                                                id="outlined-name"
                                                size="small"
                                                type="date"
                                                label="Expiry Date *"
                                                value={formik.values.expireDate}
                                                inputProps={{
                                                    min: new Date().toISOString().split('T')[0],
                                                }}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('expireDate')}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(touched.expireDate && errors.expireDate)}
                                                helperText={touched.expireDate && errors.expireDate}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            />
                                        </Stack>
                                    </Stack>
                                </Stack>
                                <Stack spacing={2} margin={3}>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Stack style={{ width: '250px' }}>
                                            <ImageUploader
                                                singleImage={true}
                                                buttonText='Upload Certification Image'
                                                onChange={onDrop}
                                                image={formik.values.image}
                                                imgExtension={['.jpg', '.png']}
                                                maxFileSize={5242880}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            />
                                        </Stack>
                                        {ImageObject != null ?
                                            <Card>
                                                <CardMedia
                                                    component="img"
                                                    height="140"
                                                    image={`data:image/jpeg;base64,${ImageObject}`}
                                                    {...getFieldProps('image')}
                                                    error={Boolean(touched.image && errors.image)}
                                                    helperText={touched.image && errors.image}
                                                />
                                                <Button
                                                    fullWidth
                                                    color="secondary"
                                                    type="button"
                                                    variant="contained"
                                                    onClick={removeImage}
                                                >
                                                    Remove
                                                </Button>
                                                <Dialog
                                                    open={open}
                                                    onClose={handleClose}
                                                    aria-labelledby="alert-dialog-title"
                                                >
                                                    <DialogTitle id="alert-dialog-title">
                                                        {"Are you sure you want to delete this image?"}
                                                    </DialogTitle>

                                                    <DialogActions>
                                                        <Button onClick={handleClose}>No</Button>
                                                        <Button onClick={handleOpen}>Yes</Button>
                                                    </DialogActions>
                                                </Dialog>
                                            </Card> : null}

                                    </Stack>
                                    <br />
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <LoadingButton
                                            size="medium"
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                            disabled={pageProps.Edit || factoryType == 1 || factoryType == 3}
                                        >
                                            Clear
                                        </LoadingButton>
                                        <LoadingButton
                                            size="medium"
                                            type="submit"
                                            variant="outlined"
                                            color='secondary'
                                            disabled={factoryType == 1 || factoryType == 3}
                                        >
                                            {pageProps.submitButtonName}
                                        </LoadingButton>
                                    </Stack>
                                </Stack>
                                <br />
                                <Divider />
                                <br />
                                <Card>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        {(farmerCertificationArray.length > 0) ?
                                            <Grid item xs={12}>
                                                <TableContainer >
                                                    <Table style={{ minWidth: 850 }} aria-label="caption table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="center">Certification Type</TableCell>
                                                                <TableCell align="center">Certification Number</TableCell>
                                                                <TableCell align="center">Expire Date</TableCell>
                                                                <TableCell align="center">Product Category</TableCell>
                                                                <TableCell align="center">Product</TableCell>
                                                                <TableCell align="center">Certification Document</TableCell>
                                                                <TableCell align="center">Action</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {farmerCertificationArray.map((rowData, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.farmerCertificationTypeName}
                                                                    </TableCell>
                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.certificationNumber}
                                                                    </TableCell>
                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.expireDate.split('T')[0]}
                                                                    </TableCell>
                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.productCategoryNames.map((productCategoryName, index) => (
                                                                            <Chip key={index} label={productCategoryName} style={{ margin: '2px' }} />
                                                                        ))}
                                                                    </TableCell>
                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.productNames.map((productName, index) => (
                                                                            <Chip key={index} label={productName} style={{ margin: '2px' }} />
                                                                        ))}
                                                                    </TableCell>
                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: 'none', textAlign: 'center' }}>
                                                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                            {settingPicture(rowData.image)}
                                                                        </div>
                                                                    </TableCell>
                                                                    <Dialog open={openA} onClose={handleCloseA}>
                                                                        <CardMedia component="img" height="400" image={selectedImage} />
                                                                    </Dialog>
                                                                    {(factoryType == 1 || factoryType == 3) ? null :
                                                                        <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            <Tooltip title="Delete">
                                                                                <IconButton
                                                                                    variant="outlined"
                                                                                    color="error"
                                                                                    onClick={() => handleConfirm(index)}>
                                                                                    <DeleteIcon />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </TableCell>}
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Grid>
                                            : null}
                                    </Stack>
                                </Card>
                            </Card>
                        </Form>
                    </FormikProvider>
                </Container>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                            discription={"Are you sure want to delete Certification details ?"} setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
            </Page >
        </>
    )
}